const key = 'questad.impersonation';
const backend = `${process.env.REACT_APP_DAILYPROFIT_BACKEND_PROTOCOL}${process.env.REACT_APP_DAILYPROFIT_BACKEND_HOST}${process.env.REACT_APP_DAILYPROFIT_BACKEND_PORT}/adminPanel/impersonation`;

export function readImpersonationSession() {
  try {
    return JSON.parse(sessionStorage.getItem(key) || 'null');
  } catch (_) {
    sessionStorage.removeItem(key);
    return null;
  }
}

export function saveImpersonationTokens(tokens) {
  const session = readImpersonationSession();
  if (!session) return;

  if (tokens.token) {
    sessionStorage.setItem(key, JSON.stringify({ ...session, ...tokens }));
    return;
  }

  sessionStorage.removeItem(key);
  fetch(`${backend}/session/logout`, {
    method: 'POST',
    credentials: 'include',
    keepalive: true,
  }).catch(() => {});
}

export async function restoreImpersonationSession() {
  const existingSession = readImpersonationSession();
  if (existingSession) return existingSession;

  const response = await fetch(`${backend}/session`, {
    credentials: 'include',
    cache: 'no-store',
  });
  if (response.status === 401) return null;

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.msg || 'Could not restore impersonation.');
  }

  sessionStorage.setItem(key, JSON.stringify(result.data));
  return result.data;
}
